import styled, { createGlobalStyle } from 'styled-components';
import { isMobile } from '../utils';
import { Modal } from '../Modal/Modal';
import { themeColor } from '../theme/colors';
import { smBold, xxlRegular } from '../theme/typography';
import blurryBackground from './blurryBackground.jpg';

export const WizardGlobalStyle = createGlobalStyle`
  div:has(> .wizard-modal) {
    background-image: url(${blurryBackground});
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    background-color: #111214; // hardcoded to match the background color of the image
    backdrop-filter: none;
  }
`;

export const StyledModal = styled(Modal)`
  padding: 0;
  min-height: 600px;
  max-height: 600px;

  display: flex;
`;

export const Sidebar = styled.div`
  width: 250px;
  ${isMobile() && 'width: 100%;'}
  padding: 32px;
  background: ${themeColor('tooltipBackground')};

  border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;

  & .logout-button {
    position: absolute;
    bottom: 32px;
  }
`;

export const SidebarTitle = styled.div`
  color: ${themeColor('textPrimary')};
  ${xxlRegular};

  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

export const Content = styled.div`
  flex: 1;
  padding: 32px;
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: none;
  border: none;
  color: ${themeColor('textTertiary')};
  ${smBold};
  gap: 8px;
`;
